import {
  initialState,
  Actions,
  State,
  GET_ONE_COMPANY,
  GET_ONE_COMPANY_SUCCESS,
  GET_ONE_COMPANY_ERROR,
  RESET_GET_ONE_COMPANY,
} from '../../types/company/get-one'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ONE_COMPANY:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case GET_ONE_COMPANY_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case GET_ONE_COMPANY_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_GET_ONE_COMPANY:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
